<template>
  <div class="product__installments">
    
    <!-- Afterpay -->
    <div v-show="showAfterpay">
      <p class="product__installments-text">
        OR 4 PAYMENTS OF  <span data-laybuy-price>{{ format(total / 4) }}</span> WITH
      </p>
      <img class="product__installments-image lazyload" data-src="https://static.afterpay.com/integration/product-page/logo-afterpay-colour@2x.png" width="62" height="13" alt="Afterpay" />
    </div>

    <!-- Laybuy -->
    <div v-show="showLaybuy">
      <p class="product__installments-text">
        OR 6 PAYMENTS OF  <span data-laybuy-price>{{ format(total / 6) }}</span> WITH
      </p>
      <img class="product__installments-image lazyload" data-src="https://www.laybuy.com/assets/laybuy-logo-small.svg" alt="Laybuy">
    </div>

  </div>
</template>

<script>
import { formatMoney } from '@shopify/theme-currency'
export default {
  props: [ 'total' ],
	computed: {
		showAfterpay () {
      return this.$store.customerCountry === 'AU'
    },
    showLaybuy () {
      return ['AU', 'NZ', 'GB'].includes(this.$store.customerCountry)
    }
  },
  methods: {
    format (amount) {
      return formatMoney(amount)
    }  
  }
}
</script>
